import Card, { CardPadding } from 'app/components/presentation/containers/card/Card';
import SectionContent from 'app/components/presentation/containers/section/SectionContent';
import React, { ReactNode } from 'react';

/**
 * Section and Card combination.
 */
const SectionCard = ({
  cardHeader,
  cardPadding = '25px',
  children,
  sectionHeader,
  sectionHeaderActionItem,
}: {
  cardHeader?: ReactNode,
  cardPadding?: CardPadding,
  children: ReactNode,
  sectionHeader?: ReactNode,
  sectionHeaderActionItem?: ReactNode,
}) => (
  <SectionContent header={sectionHeader} headerActionItem={sectionHeaderActionItem}>
    <Card header={cardHeader} padding={cardPadding}>
      {children}
    </Card>
  </SectionContent>
);

export default SectionCard;
